(async function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    let activeVariant;
    let product = JSON.parse(section.querySelector('.templateProductJSON').textContent)

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    let swiper = new Swiper(section.querySelector('.productV2VisualSwiper'), {
        navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
        }
    })
    section.querySelectorAll(`.productV2VisualThumbsThumbnail`).forEach(function (element) {
        element.addEventListener("click", function () {

            // determine index
            let index = getElIndex(this);

            // change active slide
            swiper.slideTo(index);
        });
    });

    /**
     * Build the variant options HTML
     * @param {Array} products - Array of product objects,
     * each containing variant selector information.
     */
    function constructVariantOptions(products) {
        let optionsEl = section.querySelector('.productV2FormVariant');
        optionsEl.innerHTML = '';
        let HTML = '';
        products.forEach(function (variant, index) {
            let checked = index === 0 ? 'checked' : '';

            // Overrides
            let variantTitle = variant.title;
            let overrideTitle = variantOverrides[`title${index + 1}`];
            if (overrideTitle) variantTitle = overrideTitle;

            // resolve display prices (section overrides take priority)
            let overridePrice = variantOverrides[`price${index + 1}`];
            let overrideComparePrice = variantOverrides[`comparePrice${index + 1}`];
            let displayPrice = overridePrice ? Math.round(overridePrice * 100) : (variant.custom_price ?? variant.price);
            let displayCompare = overrideComparePrice ? Math.round(overrideComparePrice * 100) : (variant.custom_compare_price ?? variant.compare_at_price);

            // calculate savings badge
            let savings = displayCompare > displayPrice
                ? Math.round((displayCompare - displayPrice) / displayCompare * 100)
                : 0;
            let badgeText = savings > 0 ? `SAVE ${savings}%` : '';
            if (badgeText && variant.save_label) badgeText += ` - ${variant.save_label}`;

            let overrideBadge = variantOverrides[`badge${index + 1}`];
            if (overrideBadge) badgeText = overrideBadge;

            let badge = badgeText ? `<span class="productV2FormVariantItemTag">${badgeText}</span>` : '';

            HTML += `
                <label class="productV2FormVariantLabel">
                    <input class="productV2FormVariantLabelInput" type="radio" name="${sectionID}-variant"
                           value="${variant.id}" ${checked}>
                    <span class="productV2FormVariantItem">
                        <span class="productV2FormVariantItemRadio">
                            <span class="productV2FormVariantItemRadioInner"></span>
                        </span>
                        <span class="productV2FormVariantItemContent">
                            <span class="productV2FormVariantItemHeader">
                                <span class="productV2FormVariantItemHeading">
                                    <span class="productV2FormVariantItemTitle">${variantTitle}</span>
                                </span>

                                <span class="productV2FormVariantItemPrices">
                                    <span class="productV2FormVariantItemPriceWrapper">
                                        ${displayCompare !== displayPrice ? `<span class="productV2FormVariantItemCompare">${price(displayCompare)}</span>` : ''}
                                        <span class="productV2FormVariantItemPriceGroup">
                                            <span class="productV2FormVariantItemPrice">${price(displayPrice, true)}</span>${variant.price_label ? `<span class="productV2FormVariantItemPriceLabel">${variant.price_label}</span>` : ''}
                                        </span>
                                    </span>
                                    ${variant.price_note ? `<span class="productV2FormVariantItemPriceNote">${variant.price_note}</span>` : ''}
                                </span>
                            </span>
                            <span class="productV2FormVariantItemMeta"></span>
                        </span>
                        ${badge}
                    </span>
                </label>
            `;
        });
        optionsEl.innerHTML = HTML;

        // inject pre-rendered meta (subtitle, billing text, bullets) into each card
        optionsEl.querySelectorAll('.productV2FormVariantLabelInput').forEach(function (input) {
            let metaSource = section.querySelector(`[data-variant-meta="${input.value}"]`);
            if (metaSource) {
                metaSource.querySelector('.productV2FormVariantItemSubtitle') && input.closest('.productV2FormVariantLabel')
                    .querySelector('.productV2FormVariantItemHeading')
                    .appendChild(metaSource.querySelector('.productV2FormVariantItemSubtitle'));

                metaSource.querySelector('.productV2FormVariantItemBillingText') && input.closest('.productV2FormVariantLabel')
                    .querySelector('.productV2FormVariantItemHeading')
                    .appendChild(metaSource.querySelector('.productV2FormVariantItemBillingText'));
                    

                metaSource.querySelector('.productV2FormVariantItemBullets') && input.closest('.productV2FormVariantLabel')
                    .querySelector('.productV2FormVariantItemMeta')
                    .appendChild(metaSource.querySelector('.productV2FormVariantItemBullets'));
            }
        });
    }

    // initialize variant options from product.variants
    constructVariantOptions(variantProducts);

    // update product on variant change
    section.querySelectorAll('.productV2FormVariantLabelInput').forEach(function (input) {
        input.addEventListener('change', function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    async function updateProduct() {

        if (!section.querySelector('.productV2FormVariantLabelInput')) {
            section.querySelector('.productV2FormATC').textContent = "Unavailable";
            section.querySelector('.productV2FormATC').disabled = true;
            section.querySelector('.productV2StickyBodyRightATCTxt').textContent = "Unavailable";
            section.querySelector('.productV2StickyBodyRightATC').disabled = true;
            return;
        }

        // find selected variant
        let selectedVariantId = parseInt(section.querySelector('.productV2FormVariantLabelInput:checked').value);
        activeVariant = variantProducts.find(v => v.id === selectedVariantId);

        // resolve display prices (section overrides take priority)
        let variantIndex = variantProducts.findIndex(v => v.id === selectedVariantId) + 1;
        let overridePrice = variantOverrides[`price${variantIndex}`];
        let overrideComparePrice = variantOverrides[`comparePrice${variantIndex}`];
        let displayPrice = overridePrice ? Math.round(overridePrice * 100) : (activeVariant.custom_price ?? activeVariant.price);
        let displayCompare = overrideComparePrice ? Math.round(overrideComparePrice * 100) : (activeVariant.custom_compare_price ?? activeVariant.compare_at_price);

        // update one-time link price (show compare/full price)
        let oneTimePriceEl = section.querySelector('.productV2FormOneTimePrice');
        if (oneTimePriceEl) {
            oneTimePriceEl.textContent = price(displayCompare);
        }

        // update active image — hide gallery while updating, show when ready
        let overrideImage = variantOverrides[`image${variantIndex}`];
        let displayImage = overrideImage || activeVariant.featured_image;

        if (displayImage) {
            // hide gallery during update
            let gallery = section.querySelector('.productV2VisualSwiper');
            gallery.style.opacity = '0';
            gallery.style.pointerEvents = 'none';

            // update or create variant thumbnail
            let existingThumb = section.querySelector('.productV2VisualThumbs .productV2VariantThumb');
            if (existingThumb) {
                existingThumb.src = displayImage;
                existingThumb.alt = activeVariant.title || '';
            } else {
                let thumbImg = document.createElement('img');
                thumbImg.className = 'productV2VisualThumbsThumbnail productV2VariantThumb';
                thumbImg.src = displayImage;
                thumbImg.alt = activeVariant.title || '';
                thumbImg.addEventListener('click', function () { swiper.slideTo(0); });
                section.querySelector('.productV2VisualThumbs').prepend(thumbImg);
            }

            // update or create variant slide
            let existingVariantSlide = section.querySelector('.productV2VisualSwiperImage.productV2VariantSlide');
            if (existingVariantSlide) {
                existingVariantSlide.src = displayImage;
                existingVariantSlide.alt = activeVariant.title || '';
                // show gallery when image loads
                existingVariantSlide.addEventListener('load', function showGallery() {
                    gallery.style.opacity = '1';
                    gallery.style.pointerEvents = 'auto';
                    existingVariantSlide.removeEventListener('load', showGallery);
                }, { once: true });
            } else {
                swiper.addSlide(0, `<img class="productV2VisualSwiperImage swiper-slide productV2VariantSlide" src="${displayImage}" alt="${activeVariant.title || ''}">`);
                // get the newly added slide and listen for load
                let newSlide = section.querySelector('.productV2VisualSwiperImage.productV2VariantSlide');
                newSlide.addEventListener('load', function showGallery() {
                    gallery.style.opacity = '1';
                    gallery.style.pointerEvents = 'auto';
                    newSlide.removeEventListener('load', showGallery);
                }, { once: true });
            }

            swiper.slideTo(0, 0);
            if (section.querySelector('.productV2StickyBodyLeftImg')) section.querySelector('.productV2StickyBodyLeftImg').src = displayImage;
        } else {
            // remove variant elements if no image
            section.querySelectorAll('.productV2VariantThumb').forEach(el => el.remove());
            if (section.querySelector('.swiper-slide.productV2VariantSlide')) {
                swiper.removeSlide(0);
            }
        }

        if (Shopify.theme.role === "development") {
            window.activeVariant = activeVariant;
        }

        // available
        if (activeVariant.available) {
            section.querySelector('.productV2FormATC').disabled = false;
            if (section.querySelector('.productV2StickyBodyRightATCTxt')) {
                section.querySelector('.productV2StickyBodyRightATCTxt').textContent = "SHOP NOW";
                section.querySelector('.productV2StickyBodyRightATC').disabled = false;
            }
        } else {
            section.querySelector('.productV2FormATC').textContent = "SOLD OUT";
            section.querySelector('.productV2FormATC').disabled = true;
            if (section.querySelector('.productV2StickyBodyRightATCTxt')) {
                section.querySelector('.productV2StickyBodyRightATCTxt').textContent = "SOLD OUT";
                section.querySelector('.productV2StickyBodyRightATC').disabled = true;
            }
        }

        // Update sticky ATC
        if (section.querySelector(".productV2StickyBodyRightOptionAmount")) {
            section.querySelector(".productV2StickyBodyRightOptionAmount").textContent = activeVariant.variant_selector?.title || "";
            section.querySelector(".productV2StickyBodyLeftMobileAmount").textContent = activeVariant.variant_selector?.title || "";
            section.querySelector(".productV2StickyBodyRightOptionInterval").textContent = activeVariant.variant_selector?.shipping_interval ?? "";
            section.querySelector(".productV2StickyBodyLeftMobileInterval").textContent = activeVariant.variant_selector?.shipping_interval ?? "";
            section.querySelector(".productV2StickyBodyRightATCCompare").textContent = displayCompare ? price(displayCompare) : "";
            section.querySelector(".productV2StickyBodyRightATCPrice").textContent = price(displayPrice);
        }

    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();


    /**************
     Product ATC
     ***************/
    async function addToCart() {

        section.querySelector(".productV2FormATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.variant_id,
                selling_plan: activeVariant.plan_id || null
            }]
        };

        // check for add ons
        section.querySelectorAll('.productV3AddOnItemBodySwitchInput:checked')?.forEach(function (element) {
            formData.items.push({
                quantity: 1,
                id: element.dataset.id,
                selling_plan: element.dataset.selling || null
            });
        });

        await addProduct(formData);
        section.querySelector(".productV2FormATC").classList.remove("loading");
        await openCart();
        await tracking(formData);
    }

    section.querySelector('.productV2FormATC').addEventListener("click", addToCart);

    // One-time purchase handler — fixed variant, no selling plan
    section.querySelector('.productV2FormOneTime')?.addEventListener('click', async function () {
        this.classList.add('loading');

        let resolvedOneTimeId = oneTimeVariantId
            || variantProducts.find(v => v.available)?.variant_id
            || activeVariant.variant_id;

        let formData = {
            items: [{
                quantity: quantity,
                id: resolvedOneTimeId,
                selling_plan: null
            }]
        };

        await addProduct(formData);
        this.classList.remove('loading');
        await openCart();
        await tracking(formData);
    });

    // Append disclaimer text only on this page template
    let disclaimerEl = document.querySelector('#footerBottomWrapLeftDisclaimer');
    if (disclaimerEl) {
        disclaimerEl.innerHTML = '*'+disclaimerEl.innerHTML.trimStart()+'<br><br>*The 90-Day Money-Back Guarantee is exclusive to the 90-Day Supply Subscription. One-tube subscriptions are covered by our standard 30-Day Money-Back Guarantee. These guarantees do not apply to one-time (non-subscription) purchases.';
    }

    // Reviews scroll
    section.querySelector('.productV2DropsItemBodyReviews').addEventListener("click", function () {
        // scroll to section of page with reviewsTarget (reviewsTarget is created in the FAQ section, based on section.id)
        window.scroll({
            top: document.querySelector(`#${reviewsTarget}`).offsetTop - 100,
            behavior: "smooth"
        })
    })

    /**************
     STICKY ATC
     ***************/
    section.querySelectorAll('.productV2StickyBodyRightATC').forEach(function (el) {
        el.addEventListener('click', function () {
            // add loading animation
            this.classList.add('loading');

            addToCart();

            // wait 1 second
            setTimeout(function () {
                // remove loading animation
                el.classList.remove('loading');
            }, 1000);
        });
    });

    /************
     Dynamic Sold Out
     ************/
    (function () {
        // Get the current date and time
        let currentDate = new Date();
        // let currentDate = new Date("2024-05-29T23:59:00");

        // The date everything is relative to - which is a Sunday.
        let targetDate = new Date("2024-04-28T23:59:00");

        // Increment the counter for every day that has passed
        let daysPassed = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24) % 7);

        // get the next monday from current date
        let nextMonday = new Date(currentDate);
        nextMonday.setDate(currentDate.getDate() + 8 - currentDate.getDay());

        // get the last monday from current date
        let lastMonday = new Date(currentDate);
        lastMonday.setDate(currentDate.getDate() + 1 - currentDate.getDay());

        // Update the text with the incremented number
        section.querySelectorAll(".percentSold")?.forEach(function (element) {
            element.textContent = daysPassed + 91;
        });

        // Update the date with the next monday
        section.querySelectorAll(".preOrderDate")?.forEach(function (element) {
            element.textContent = nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });

        // Update the date with the last Monday
        section.querySelectorAll(".lastOrderDate")?.forEach(function (element) {
            element.textContent = lastMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });
    })();


    // dropdown event listeners for each of the titles
    section.querySelectorAll(`.productV2DropsItemTitle`).forEach(function (element) {
        element.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });

    // random number gen (23-100) for checking out now text
    section.querySelectorAll(".productV2CheckingOutNum").forEach(function (element) {
        element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
    });
    // Do it every 3 seconds
    setInterval(function () {
        section.querySelectorAll(".productV2CheckingOutNum").forEach(function (element) {
            element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
        });
    }, 3000);


    /**************
     Product Add On
     ***************/
        // swiper
    let hasAddOns = section.querySelector('.productV3AddOn') || false;
    if (hasAddOns) {
        let addOnSwiper = new Swiper(section.querySelector('.productV3AddOn'), {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: section.querySelector('.productV3AddOnPag'),
                clickable: true,
            },
            breakpoints: {},
        });
    }


    /************
     GA4 & Klaviyo Tracking
     ************/
    async function tracking(formData) {

        // GA4 add_to_cart
        const sourceProduct = product;
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: Shopify.currency.active,
                value: sourceProduct.variants[0].price * quantity / 100,
                items: [{
                    item_id: sourceProduct.id,
                    item_name: sourceProduct.title,
                    item_category: sourceProduct.type,
                    item_variant: sourceProduct.variants[0].title,
                    price: sourceProduct.variants[0].price / 100,
                    quantity: quantity,
                    subscription_item: !!formData.selling_plan,
                }],
                subscription_included: !!formData.selling_plan,
            }
        });

        // push to klavviyo
        try {
            _learnq.push(["track", "Added to Cart", {
                "$value": sourceProduct.price * quantity / 100,
                "AddedItemProductName": sourceProduct.title,
                "AddedItemProductID": sourceProduct.id,
                "AddedItemSKU": sourceProduct.variants[0].sku,
                "AddedItemCategories": sourceProduct.tags,
                "AddedItemImageURL": sourceProduct.featured_image?.src,
                "AddedItemURL": `https://getlivfresh.com/products/${product.handle}`,
                "AddedItemPrice": sourceProduct.price,
                "AddedItemQuantity": 1,
                "ItemNames": [sourceProduct.title],
                "CheckoutURL": "https://livfresh.com/checkout",
                "Items": [{
                    "ProductID": sourceProduct.id,
                    "SKU": sourceProduct.variants[0].sku,
                    "ProductName": sourceProduct.title,
                    "Quantity": quantity,
                    "ItemPrice": sourceProduct.price / 100,
                    "RowTotal": sourceProduct.price * quantity / 100,
                    "ProductURL": `https://getlivfresh.com/products/${product.handle}`,
                    "ImageURL": sourceProduct.featured_image?.src,
                    "ProductCategories": sourceProduct.tags
                }]
            }]);
        } catch (e) {
            console.log(e)
        }
    }


}());